<template>
	<div class="space-y-1">
		<label class="block text-sm font-medium text-gray-700">{{ label }}</label>
		<div class="gap-2 flex items-center">
			<button
				@click="updateValue(true)"
				class="px-3 py-2 rounded-md cursor-pointer transition-all duration-200 text-sm font-medium outline outline-2 outline-offset-2"
				:class="modelValue ? 'outline-black' : 'bg-white text-gray-700 outline-white/0 hover:outline-black/20 hover:bg-gray-50'"
			>
				Enable
			</button>
			<button
				@click="updateValue(false)"
				class="px-3 py-2 rounded-md cursor-pointer transition-all duration-200 text-sm font-medium outline outline-2 outline-offset-2"
				:class="!modelValue ? 'outline-black' : 'bg-white text-gray-700 outline-white/0 hover:outline-black/20 hover:bg-gray-50'"
			>
				Disable
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EnableDisableToggle',
	props: {
		modelValue: {
			type: Boolean,
			default: true
		},
		label: {
			type: String,
			default: 'Action'
		}
	},
	emits: ['update:modelValue'],
	methods: {
		updateValue(value) {
			this.$emit('update:modelValue', value)
		}
	}
}
</script>